import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import RefData from 'ref-data';

import { exportEnums } from '../../common/enums';

import ExportTaskActions from './export-task-actions';

const defaultConfig = {
  activeTask:                {},
  isCurrentExportGenerating: false,
  isCurrentExportComplete:   false,
  isCurrentExportFailed:     false,
  isInitialLoad:             true,
  isLoading:                 false,
  exportPassword:            undefined,
  exportError:               undefined,
};

const initialState = Immutable({
  byExportType: {
    [exportEnums.exportTypes.PARTICIPANTS]: defaultConfig,
    [exportEnums.exportTypes.COUPONS]:      defaultConfig,
  },
});

const reducer = createReducer((on) => {
  //=============================================
  // ADD A NEW EXPORT
  //=============================================

  on(ExportTaskActions.generateNewExportTaskSuccess, (state, { exportTask, exportType }) => {
    const _path = ['byExportType', exportType];
    const _data = _.get(state, _path);
    return state.setIn(
      _path,
      _data.merge({
        exportPassword:            exportTask.password,
        isCurrentExportGenerating: true,
        activeTask:                exportTask,
        exportError:               undefined,
      })
    );
  });

  on(ExportTaskActions.generateNewExportTaskFailure, (state, { error, exportType }) => {
    const _path = ['byExportType', exportType];
    const _data = _.get(state, _path);
    return state.setIn(
      _path,
      _data.merge({
        activeTask:                defaultConfig.activeTask,
        isCurrentExportGenerating: false,
        exportError:               error,
      })
    );
  });

  //=============================================
  // POLLING THE EXPORT
  //=============================================

  on(ExportTaskActions.startPollingExportTask, (state, { exportType }) => {
    const _path = ['byExportType', exportType];
    const _data = _.get(state, _path);
    return state.setIn(
      _path,
      _data.merge({
        isCurrentExportGenerating: true,
        exportError:               undefined,
      })
    );
  });

  on(ExportTaskActions.completePollingExportTask, (state, { exportType }) => {
    const _path = ['byExportType', exportType];
    const _data = _.get(state, _path);
    const _status = _.get(state, ['byExportType', exportType, 'activeTask', 'status', 'id'], '');
    return state.setIn(
      _path,
      _data.merge({
        isCurrentExportGenerating: RefData.Enum.STATUS.EXPORT.INPROGRESS === _status,
        isCurrentExportFailed:     RefData.Enum.STATUS.EXPORT.FAILED === _status,
        isCurrentExportComplete:   RefData.Enum.STATUS.EXPORT.FINISHED === _status,
      })
    );
  });

  //=============================================
  // FETCH DETAILS OF LAST EXPORT
  //=============================================

  on(ExportTaskActions.fetchLastExportSuccess, (state, { exportTask, exportType }) => {
    const _path = ['byExportType', exportType];
    const _data = _.get(state, _path);
    return state.setIn(
      _path,
      _data.merge({
        activeTask:  exportTask,
        exportError: undefined,
      })
    );
  });

  on(ExportTaskActions.fetchLastExportFailure, (state, { error, exportType }) => {
    const _path = ['byExportType', exportType];
    const _data = _.get(state, _path);
    return state.setIn(
      _path,
      _data.merge({
        activeTask:  defaultConfig.activeTask,
        exportError: error,
      })
    );
  });
}, initialState);

export default reducer;
